import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormAutocompleteField from 'components/ui/form/FormAutocompleteField';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useFormSubmit from 'hooks/useFormSubmit';
import { useState } from 'react';
import { useQuery } from 'react-query';
import * as yup from 'yup';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(4, { label: 'settings.staff.validation.nameMin', value: 4 })
    .required('settings.staff.validation.name'),
  user_id: yup.number().required('Odam tanlash majburiy'),
});

const AddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemId, setItemId } = props;
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      user_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemId) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/master',
          values.name,
          itemId,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          '/admin/master',
          values.name,
          null,
          false,
          handleFinishRequest
        );
    },
  });

  const { isLoading, isFetching } = useQuery({
    queryKey: ['/admin/master/edit/{itemId}', itemId],
    queryFn: async function () {
      const response = await axiosPrivate.get(`/admin/master/edit/${itemId}`);
      return response.data.data;
    },
    onSuccess: (data) => {
      formik.setValues({
        name: data?.name,
        user_id: data?.user_id,
      });
    },
    enabled: !hasError && !!itemId,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemId('');
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
    >
      <DialogTitle id='alert-dialog-title'>
        {itemId ? <span>Master tahrirlash</span> : <span>Master qo'shish</span>}
        <div className='close-btn-wrapper'>
          <IconButton variant='onlyIcon' color='primary' onClick={handleClose}>
            <i className='bi bi-x' />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        {isLoading || isFetching ? (
          <div className='circular-progress-box py-5'>
            <CircularProgress size={35} />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              spacing={{ xs: 2, sm: 3, lg: 3 }}
              rowSpacing={1}
              columns={{ xs: 12, sm: 12, lg: 12 }}
            >
              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormTextField
                  delay={0.1}
                  label={'Master nomi'}
                  fieldName='name'
                  formik={formik}
                />
              </Grid>

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormAutocompleteField
                  delay={0.4}
                  label={'Odamlar'}
                  fieldName='user_id'
                  formik={formik}
                  path={'/dictionary/staffs'}
                />
              </Grid>

              <Grid item={true} sm={12} xs={12}>
                <FormActionButtons
                  delay={0.6}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddEditModal;
